/* src/app/private/components/fee-structure/delete-fee-structure/delete-fee-structure.component.scss */
/*# sourceMappingURL=delete-fee-structure.component.css.map */
